var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col-md-8 left" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sidebar.appearance")) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          !_vm.edited
            ? [
                _c("div", { staticClass: "click-to-shake" }, [
                  _c("section", [
                    _c(
                      "div",
                      { staticClass: "col-md-12 no-padding" },
                      [
                        _c("section-header", {
                          attrs: { title: _vm.$t("message.formats") }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("div", { staticClass: "form-row" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-12",
                                  staticStyle: { height: "24px" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.formatnumberandusecomma"
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group col-4",
                                  staticStyle: { "padding-right": "0" }
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.form.selectDecimalPlacesFormat,
                                          expression:
                                            "form.selectDecimalPlacesFormat"
                                        }
                                      ],
                                      staticClass: "custom-select form-control",
                                      staticStyle: {
                                        "border-radius": ".25rem 0 0 .25rem"
                                      },
                                      attrs: { disabled: "" },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.form,
                                            "selectDecimalPlacesFormat",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "0" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("message.decimalplaces", {
                                              number: 0
                                            })
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "1" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("message.decimalplaces", {
                                              number: 1
                                            })
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "2" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("message.decimalplaces", {
                                              number: 2
                                            })
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group col-4",
                                  staticStyle: { padding: "0" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "box-input active",
                                      staticStyle: { "border-radius": "0" }
                                    },
                                    [
                                      _c(
                                        "vs-checkbox",
                                        {
                                          staticStyle: {
                                            float: "left",
                                            position: "relative",
                                            top: "1px",
                                            left: "-5px"
                                          },
                                          attrs: {
                                            disabled: true,
                                            color: "#A3CA76"
                                          },
                                          model: {
                                            value: _vm.form.checkboxUsecomma,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "checkboxUsecomma",
                                                $$v
                                              )
                                            },
                                            expression: "form.checkboxUsecomma"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                _vm.$t("message.usecomma")
                                              ) +
                                              "\n                      "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group col-4",
                                  staticStyle: { "padding-left": "0" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "box-input active" },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.formatnumberpreview",
                                              {
                                                string: _vm.previewFormatNumber
                                              }
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.formatdate")))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.selectDateFormat,
                                        expression: "form.selectDateFormat"
                                      }
                                    ],
                                    staticClass: "custom-select form-control",
                                    attrs: { disabled: "" },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.form,
                                          "selectDateFormat",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      { attrs: { value: "YYYY/MM/DD" } },
                                      [_vm._v("YYYY/MM/DD")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "YYYY/DD/MM" } },
                                      [_vm._v("YYYY/DD/MM")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "DD/MM/YYYY" } },
                                      [_vm._v("DD/MM/YYYY")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "MM/DD/YYYY" } },
                                      [_vm._v("MM/DD/YYYY")]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ])
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("section", [
                    _c(
                      "div",
                      { staticClass: "col-md-12 no-padding" },
                      [
                        _c("section-header", {
                          attrs: { title: _vm.$t("message.local") }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("message.currency")))
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.selectCurrency,
                                    expression: "form.selectCurrency"
                                  }
                                ],
                                staticClass: "custom-select form-control",
                                attrs: { disabled: "" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.form,
                                      "selectCurrency",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              _vm._l(_vm.currencyOptions, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "option",
                                  {
                                    key: index,
                                    domProps: { value: item.value }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.text) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-6" }, [
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("message.language")))
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.selectLanguage,
                                    expression: "form.selectLanguage"
                                  }
                                ],
                                staticClass: "custom-select form-control",
                                attrs: { disabled: "" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.form,
                                      "selectLanguage",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c("option", { attrs: { value: "en" } }, [
                                  _vm._v("English")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "th" } }, [
                                  _vm._v("ภาษาไทย")
                                ])
                              ]
                            )
                          ])
                        ])
                      ],
                      1
                    )
                  ])
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.edited
            ? [
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.formats") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "col-md-12",
                                staticStyle: { height: "24px" }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t("message.formatnumberandusecomma")
                                    ) +
                                    "\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-group col-4",
                                staticStyle: { "padding-right": "0" }
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.form.selectDecimalPlacesFormat,
                                        expression:
                                          "form.selectDecimalPlacesFormat"
                                      }
                                    ],
                                    staticClass: "custom-select form-control",
                                    staticStyle: {
                                      "border-radius": ".25rem 0 0 .25rem"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.form,
                                          "selectDecimalPlacesFormat",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { attrs: { value: "0" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("message.decimalplaces", {
                                            number: 0
                                          })
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "1" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("message.decimalplaces", {
                                            number: 1
                                          })
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "2" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("message.decimalplaces", {
                                            number: 2
                                          })
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-group col-4",
                                staticStyle: { padding: "0" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "box-input" },
                                  [
                                    _c(
                                      "vs-checkbox",
                                      {
                                        staticStyle: {
                                          float: "left",
                                          position: "relative",
                                          top: "0",
                                          left: "-5px"
                                        },
                                        attrs: { color: "#A3CA76" },
                                        model: {
                                          value: _vm.form.checkboxUsecomma,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "checkboxUsecomma",
                                              $$v
                                            )
                                          },
                                          expression: "form.checkboxUsecomma"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(_vm.$t("message.usecomma")) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-group col-4",
                                staticStyle: { "padding-left": "0" }
                              },
                              [
                                _c("div", { staticClass: "box-input active" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("message.formatnumberpreview", {
                                          string: _vm.previewFormatNumber
                                        })
                                      ) +
                                      "\n                  "
                                  )
                                ])
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.formatdate")))
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.selectDateFormat,
                                      expression: "form.selectDateFormat"
                                    }
                                  ],
                                  staticClass: "custom-select form-control",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.form,
                                        "selectDateFormat",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "YYYY/MM/DD" } },
                                    [_vm._v("YYYY/MM/DD")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "YYYY/DD/MM" } },
                                    [_vm._v("YYYY/DD/MM")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "DD/MM/YYYY" } },
                                    [_vm._v("DD/MM/YYYY")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "MM/DD/YYYY" } },
                                    [_vm._v("MM/DD/YYYY")]
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.local") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("message.currency")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.selectCurrency,
                                  expression: "form.selectCurrency"
                                }
                              ],
                              staticClass: "custom-select form-control",
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.form,
                                    "selectCurrency",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            _vm._l(_vm.currencyOptions, function(item, index) {
                              return _c(
                                "option",
                                { key: index, domProps: { value: item.value } },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(item.text) +
                                      "\n                "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("message.language")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.selectLanguage,
                                  expression: "form.selectLanguage"
                                }
                              ],
                              staticClass: "custom-select form-control",
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.form,
                                    "selectLanguage",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "en" } }, [
                                _vm._v("English")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "th" } }, [
                                _vm._v("ภาษาไทย")
                              ])
                            ]
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "action-bar" }, [
                  !_vm.$store.state.app.loading
                    ? _c("div", { staticClass: "col-md-12 text-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-web",
                            on: {
                              click: function($event) {
                                return _vm.save()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.save")))]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.state.app.loading
                    ? _c("div", { staticClass: "col-md-12 text-right" }, [
                        _vm._m(1)
                      ])
                    : _vm._e()
                ])
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 right" }, [
      _c("div", { staticClass: "action" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d3cf9b5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d3cf9b5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/settings/appearance/All.vue
// module id = null
// module chunks = 